// import React from "react";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import "./style.scss";
import { useHistory } from "react-router-dom";

import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import logo from "../../assets/img/logo.svg";
import routes from "routes.js";
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';

var ps;

function Sidebar(props) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const history = useHistory();
  const sidebar = useRef();
  const [brandName, setbrandName] = useState();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const logoutK = () => {
    localStorage.setItem("openCanvasToken", null);
    history.push("/adminlogin");
  };

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  const getBrand = () => {
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        // brandname = prop.name;
        setbrandName(prop.name);
      }
      return null;
    });
  };

  useEffect(() => {
    getBrand();
  });

  const [activeKey, setActiveKey] = useState();

  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <div className="logo">
        <Link to="/admin/dashboard" className="simple-text logo-mini ">
          <div className="logo-img text-left">
            <img className="px-2" src={logo} alt="react-logo" />
          </div>
        </Link>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          <li>
            <Link
              to={`/admin/quickanalytics`}
              className={
                "nav-link " + (brandName === "Quick analytics" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              {/* <svg
                width="24"
                height="24"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M26.272 11.7437C26.2714 11.7431 26.2708 11.7425 26.2702 11.7418L15.2563 0.728394C14.7869 0.258728 14.1627 0 13.4988 0C12.8349 0 12.2107 0.258522 11.741 0.728188L0.732953 11.7361C0.729245 11.7398 0.725537 11.7437 0.721829 11.7474C-0.242221 12.717 -0.240573 14.2902 0.726567 15.2573C1.16842 15.6994 1.752 15.9554 2.37596 15.9822C2.4013 15.9847 2.42684 15.9859 2.45259 15.9859H2.89156V24.0912C2.89156 25.695 4.19653 27 5.80081 27H10.1098C10.5465 27 10.9008 26.6459 10.9008 26.209V19.8545C10.9008 19.1226 11.4961 18.5273 12.228 18.5273H14.7696C15.5015 18.5273 16.0968 19.1226 16.0968 19.8545V26.209C16.0968 26.6459 16.4509 27 16.8878 27H21.1968C22.8011 27 24.106 25.695 24.106 24.0912V15.9859H24.5131C25.1768 15.9859 25.8009 15.7274 26.2708 15.2577C27.239 14.289 27.2394 12.7131 26.272 11.7437Z"
                />
              </svg> */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.53988 2H7.91988C9.32988 2 10.4599 3.15 10.4599 4.561V7.97C10.4599 9.39 9.32988 10.53 7.91988 10.53H4.53988C3.13988 10.53 1.99988 9.39 1.99988 7.97V4.561C1.99988 3.15 3.13988 2 4.53988 2ZM4.53988 13.4697H7.91988C9.32988 13.4697 10.4599 14.6107 10.4599 16.0307V19.4397C10.4599 20.8497 9.32988 21.9997 7.91988 21.9997H4.53988C3.13988 21.9997 1.99988 20.8497 1.99988 19.4397V16.0307C1.99988 14.6107 3.13988 13.4697 4.53988 13.4697ZM19.46 2H16.08C14.67 2 13.54 3.15 13.54 4.561V7.97C13.54 9.39 14.67 10.53 16.08 10.53H19.46C20.86 10.53 22 9.39 22 7.97V4.561C22 3.15 20.86 2 19.46 2ZM16.08 13.4697H19.46C20.86 13.4697 22 14.6107 22 16.0307V19.4397C22 20.8497 20.86 21.9997 19.46 21.9997H16.08C14.67 21.9997 13.54 20.8497 13.54 19.4397V16.0307C13.54 14.6107 14.67 13.4697 16.08 13.4697Z"
                  fill="#9A9AA9"
                />
              </svg>
              <p className="">Dashboard</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/dashboard`}
              className={
                "nav-link " + (brandName === "Dashboard" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              {/* <svg
                width="24"
                height="24"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M26.272 11.7437C26.2714 11.7431 26.2708 11.7425 26.2702 11.7418L15.2563 0.728394C14.7869 0.258728 14.1627 0 13.4988 0C12.8349 0 12.2107 0.258522 11.741 0.728188L0.732953 11.7361C0.729245 11.7398 0.725537 11.7437 0.721829 11.7474C-0.242221 12.717 -0.240573 14.2902 0.726567 15.2573C1.16842 15.6994 1.752 15.9554 2.37596 15.9822C2.4013 15.9847 2.42684 15.9859 2.45259 15.9859H2.89156V24.0912C2.89156 25.695 4.19653 27 5.80081 27H10.1098C10.5465 27 10.9008 26.6459 10.9008 26.209V19.8545C10.9008 19.1226 11.4961 18.5273 12.228 18.5273H14.7696C15.5015 18.5273 16.0968 19.1226 16.0968 19.8545V26.209C16.0968 26.6459 16.4509 27 16.8878 27H21.1968C22.8011 27 24.106 25.695 24.106 24.0912V15.9859H24.5131C25.1768 15.9859 25.8009 15.7274 26.2708 15.2577C27.239 14.289 27.2394 12.7131 26.272 11.7437Z"
                />
              </svg> */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M16.25 22.5C17.2165 22.5 18 21.7165 18 20.75C18 19.7835 17.2165 19 16.25 19C15.2835 19 14.5 19.7835 14.5 20.75C14.5 21.7165 15.2835 22.5 16.25 22.5Z"
                  fill="#767676"
                />
                <path
                  d="M8.25 22.5C9.2165 22.5 10 21.7165 10 20.75C10 19.7835 9.2165 19 8.25 19C7.2835 19 6.5 19.7835 6.5 20.75C6.5 21.7165 7.2835 22.5 8.25 22.5Z"
                  fill="#767676"
                />
                <path
                  d="M4.84 3.94L4.64 6.39C4.6 6.86 4.97 7.25 5.44 7.25H20.75C21.17 7.25 21.52 6.93 21.55 6.51C21.68 4.74 20.33 3.3 18.56 3.3H6.27C6.17 2.86 5.97 2.44 5.66 2.09C5.16 1.56 4.46 1.25 3.74 1.25H2C1.59 1.25 1.25 1.59 1.25 2C1.25 2.41 1.59 2.75 2 2.75H3.74C4.05 2.75 4.34 2.88 4.55 3.1C4.76 3.33 4.86 3.63 4.84 3.94Z"
                  fill="#767676"
                />
                <path
                  d="M20.5101 8.75H5.17005C4.75005 8.75 4.41005 9.07 4.37005 9.48L4.01005 13.83C3.87005 15.54 5.21005 17 6.92005 17H18.0401C19.5401 17 20.8601 15.77 20.9701 14.27L21.3001 9.6C21.3401 9.14 20.9801 8.75 20.5101 8.75Z"
                  fill="#767676"
                />
              </svg>
              <p className="">Products</p>
            </Link>
          </li>
          {/* <li>
            <Link
              to={`/admin/product`}
              className={
                "nav-link " + (brandName === "Product" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M16.25 22.5C17.2165 22.5 18 21.7165 18 20.75C18 19.7835 17.2165 19 16.25 19C15.2835 19 14.5 19.7835 14.5 20.75C14.5 21.7165 15.2835 22.5 16.25 22.5Z"
                  fill="#767676"
                />
                <path
                  d="M8.25 22.5C9.2165 22.5 10 21.7165 10 20.75C10 19.7835 9.2165 19 8.25 19C7.2835 19 6.5 19.7835 6.5 20.75C6.5 21.7165 7.2835 22.5 8.25 22.5Z"
                  fill="#767676"
                />
                <path
                  d="M4.84 3.94L4.64 6.39C4.6 6.86 4.97 7.25 5.44 7.25H20.75C21.17 7.25 21.52 6.93 21.55 6.51C21.68 4.74 20.33 3.3 18.56 3.3H6.27C6.17 2.86 5.97 2.44 5.66 2.09C5.16 1.56 4.46 1.25 3.74 1.25H2C1.59 1.25 1.25 1.59 1.25 2C1.25 2.41 1.59 2.75 2 2.75H3.74C4.05 2.75 4.34 2.88 4.55 3.1C4.76 3.33 4.86 3.63 4.84 3.94Z"
                  fill="#767676"
                />
                <path
                  d="M20.5101 8.75H5.17005C4.75005 8.75 4.41005 9.07 4.37005 9.48L4.01005 13.83C3.87005 15.54 5.21005 17 6.92005 17H18.0401C19.5401 17 20.8601 15.77 20.9701 14.27L21.3001 9.6C21.3401 9.14 20.9801 8.75 20.5101 8.75Z"
                  fill="#767676"
                />
              </svg>
              <p className="">Products</p>
            </Link>
          </li> */}
          <li>
            <Link
              to={`/admin/ratelist`}
              className={
                "nav-link " + (brandName === "Ratelist" ? "active" : "")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_5053_12480)">
                  <path
                    d="M7.97569 2.8778C7.92567 2.71779 7.79567 2.59779 7.63069 2.5528L5.58571 1.99279L4.42075 0.217815C4.23576 -0.0621883 3.76579 -0.0621883 3.58074 0.217815L2.41579 1.99279L0.370812 2.5528C0.205826 2.59779 0.075828 2.71779 0.0258093 2.8778C-0.0291859 3.0378 0.00580181 3.21777 0.110816 3.34777L1.44081 5.00275L1.33579 7.12274C1.33082 7.29275 1.40577 7.45271 1.54577 7.55274C1.68079 7.65273 1.85578 7.67777 2.01574 7.61774L4.0007 6.86274L5.98565 7.61774C6.04568 7.63775 6.10565 7.64775 6.16567 7.64775C6.26566 7.64775 6.37067 7.61774 6.45568 7.55274C6.59568 7.45276 6.67068 7.29275 6.66566 7.12274L6.56064 5.00275L7.89063 3.34777C7.9957 3.21777 8.03068 3.03775 7.97569 2.8778Z"
                    fill="#767676"
                  />
                  <path
                    d="M18.5001 2.49121H10.0002V3.49118H18.5001V2.49121Z"
                    fill="#767676"
                  />
                  <path
                    d="M24 4.99121H10.0002V5.99118H24V4.99121Z"
                    fill="#767676"
                  />
                  <path
                    d="M7.97569 11.0524C7.92567 10.8924 7.79567 10.7675 7.63069 10.7225L5.58571 10.1625L4.4207 8.38749C4.23571 8.10749 3.76574 8.10749 3.58069 8.38749L2.41569 10.1625L0.370812 10.7225C0.205826 10.7675 0.075828 10.8925 0.0258093 11.0524C-0.0291859 11.2125 0.00580181 11.3874 0.110816 11.5174L1.44081 13.1724L1.33579 15.2974C1.33082 15.4624 1.40577 15.6274 1.54577 15.7224C1.68079 15.8224 1.85578 15.8474 2.01574 15.7874L4.0007 15.0374L5.98565 15.7874C6.04568 15.8074 6.10565 15.8224 6.16567 15.8224C6.26566 15.8224 6.37067 15.7874 6.45568 15.7224C6.59568 15.6274 6.67068 15.4624 6.66566 15.2974L6.56064 13.1724L7.89063 11.5174C7.9957 11.3874 8.03068 11.2125 7.97569 11.0524Z"
                    fill="#767676"
                  />
                  <path
                    d="M18.5001 10.491H10.0002V11.4909H18.5001V10.491Z"
                    fill="#767676"
                  />
                  <path
                    d="M24 12.991H10.0002V13.9909H24V12.991Z"
                    fill="#767676"
                  />
                  <path
                    d="M7.97569 19.2223C7.92567 19.0623 7.79567 18.9373 7.63069 18.8923L5.58571 18.3374L4.4207 16.5574C4.23571 16.2774 3.76574 16.2774 3.58069 16.5574L2.41569 18.3374L0.370812 18.8923C0.205826 18.9373 0.075828 19.0624 0.0258093 19.2223C-0.0291859 19.3823 0.00580181 19.5573 0.110816 19.6873L1.44081 21.3473L1.33579 23.4673C1.33082 23.6373 1.40577 23.7972 1.54577 23.8973C1.68079 23.9923 1.85578 24.0173 2.01574 23.9573L4.0007 23.2073L5.98565 23.9573C6.04568 23.9823 6.10565 23.9923 6.16567 23.9923C6.26566 23.9923 6.37067 23.9573 6.45568 23.8973C6.59568 23.7973 6.67068 23.6373 6.66566 23.4673L6.56064 21.3473L7.89063 19.6873C7.9957 19.5573 8.03068 19.3823 7.97569 19.2223Z"
                    fill="#767676"
                  />
                  <path
                    d="M18.5001 18.991H10.0002V19.9909H18.5001V18.991Z"
                    fill="#767676"
                  />
                  <path
                    d="M24 21.4907H10.0002V22.4907H24V21.4907Z"
                    fill="#767676"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5053_12480">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p className="">Rate list</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/category`}
              className={
                "nav-link " + (brandName === "Category" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM9.97 14.9L7.72 17.15C7.57 17.3 7.38 17.37 7.19 17.37C7 17.37 6.8 17.3 6.66 17.15L5.91 16.4C5.61 16.11 5.61 15.63 5.91 15.34C6.2 15.05 6.67 15.05 6.97 15.34L7.19 15.56L8.91 13.84C9.2 13.55 9.67 13.55 9.97 13.84C10.26 14.13 10.26 14.61 9.97 14.9ZM9.97 7.9L7.72 10.15C7.57 10.3 7.38 10.37 7.19 10.37C7 10.37 6.8 10.3 6.66 10.15L5.91 9.4C5.61 9.11 5.61 8.63 5.91 8.34C6.2 8.05 6.67 8.05 6.97 8.34L7.19 8.56L8.91 6.84C9.2 6.55 9.67 6.55 9.97 6.84C10.26 7.13 10.26 7.61 9.97 7.9ZM17.56 16.62H12.31C11.9 16.62 11.56 16.28 11.56 15.87C11.56 15.46 11.9 15.12 12.31 15.12H17.56C17.98 15.12 18.31 15.46 18.31 15.87C18.31 16.28 17.98 16.62 17.56 16.62ZM17.56 9.62H12.31C11.9 9.62 11.56 9.28 11.56 8.87C11.56 8.46 11.9 8.12 12.31 8.12H17.56C17.98 8.12 18.31 8.46 18.31 8.87C18.31 9.28 17.98 9.62 17.56 9.62Z"
                  fill="#767676"
                />
              </svg>
              <p className="">Category</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/order`}
              className={
                "nav-link " +
                (brandName === "Order"
                  ? "active"
                  : brandName === "OrderDetail"
                    ? "active"
                    : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M16.25 22.5C17.2165 22.5 18 21.7165 18 20.75C18 19.7835 17.2165 19 16.25 19C15.2835 19 14.5 19.7835 14.5 20.75C14.5 21.7165 15.2835 22.5 16.25 22.5Z"
                  fill="#767676"
                />
                <path
                  d="M8.25 22.5C9.2165 22.5 10 21.7165 10 20.75C10 19.7835 9.2165 19 8.25 19C7.2835 19 6.5 19.7835 6.5 20.75C6.5 21.7165 7.2835 22.5 8.25 22.5Z"
                  fill="#767676"
                />
                <path
                  d="M4.84 3.94L4.64 6.39C4.6 6.86 4.97 7.25 5.44 7.25H20.75C21.17 7.25 21.52 6.93 21.55 6.51C21.68 4.74 20.33 3.3 18.56 3.3H6.27C6.17 2.86 5.97 2.44 5.66 2.09C5.16 1.56 4.46 1.25 3.74 1.25H2C1.59 1.25 1.25 1.59 1.25 2C1.25 2.41 1.59 2.75 2 2.75H3.74C4.05 2.75 4.34 2.88 4.55 3.1C4.76 3.33 4.86 3.63 4.84 3.94Z"
                  fill="#767676"
                />
                <path
                  d="M20.5101 8.75H5.17005C4.75005 8.75 4.41005 9.07 4.37005 9.48L4.01005 13.83C3.87005 15.54 5.21005 17 6.92005 17H18.0401C19.5401 17 20.8601 15.77 20.9701 14.27L21.3001 9.6C21.3401 9.14 20.9801 8.75 20.5101 8.75Z"
                  fill="#767676"
                />
              </svg>

              <p className="">Orders</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/customer`}
              className={
                "nav-link " +
                (brandName === "Customer"
                  ? "active"
                  : brandName === "CustomerDetail"
                    ? "active"
                    : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
                  fill="#767676"
                />
                <path
                  d="M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z"
                  fill="#767676"
                />
                <path
                  d="M19.9901 7.33999C20.1501 9.27999 18.7701 10.98 16.8601 11.21C16.8501 11.21 16.8501 11.21 16.8401 11.21H16.8101C16.7501 11.21 16.6901 11.21 16.6401 11.23C15.6701 11.28 14.7801 10.97 14.1101 10.4C15.1401 9.47999 15.7301 8.09999 15.6101 6.59999C15.5401 5.78999 15.2601 5.04999 14.8401 4.41999C15.2201 4.22999 15.6601 4.10999 16.1101 4.06999C18.0701 3.89999 19.8201 5.35999 19.9901 7.33999Z"
                  fill="#767676"
                />
                <path
                  d="M21.99 16.59C21.91 17.56 21.29 18.4 20.25 18.97C19.25 19.52 17.99 19.78 16.74 19.75C17.46 19.1 17.88 18.29 17.96 17.43C18.06 16.19 17.47 15 16.29 14.05C15.62 13.52 14.84 13.1 13.99 12.79C16.2 12.15 18.98 12.58 20.69 13.96C21.61 14.7 22.08 15.63 21.99 16.59Z"
                  fill="#767676"
                />
              </svg>
              <p className="">Customers</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/ourstaff`}
              className={
                "nav-link " + (brandName === "Ourstaff" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"
                  fill="#767676"
                />
                <path
                  d="M20.7901 14.7C19.6701 15.45 18.1001 15.73 16.6501 15.54C17.0301 14.72 17.2301 13.81 17.2401 12.85C17.2401 11.85 17.0201 10.9 16.6001 10.07C18.0801 9.87 19.6501 10.15 20.7801 10.9C22.3601 11.94 22.3601 13.65 20.7901 14.7Z"
                  fill="#767676"
                />
                <path
                  d="M6.43991 7.77C6.50991 7.76 6.57991 7.76 6.64991 7.77C8.19991 7.72 9.42991 6.45 9.42991 4.89C9.42991 3.29 8.13991 2 6.53991 2C4.94991 2 3.65991 3.29 3.65991 4.89C3.65991 6.45 4.88991 7.72 6.43991 7.77Z"
                  fill="#767676"
                />
                <path
                  d="M6.55012 12.85C6.55012 13.82 6.76012 14.74 7.14012 15.57C5.73012 15.72 4.26012 15.42 3.18012 14.71C1.60012 13.66 1.60012 11.95 3.18012 10.9C4.25012 10.18 5.76012 9.89 7.18012 10.05C6.77012 10.89 6.55012 11.84 6.55012 12.85Z"
                  fill="#767676"
                />
                <path
                  d="M12.12 15.87C12.04 15.86 11.95 15.86 11.86 15.87C10.02 15.81 8.55005 14.3 8.55005 12.44C8.56005 10.54 10.09 9 12 9C13.9 9 15.44 10.54 15.44 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z"
                  fill="#767676"
                />
                <path
                  d="M8.87005 17.94C7.36005 18.95 7.36005 20.61 8.87005 21.61C10.59 22.76 13.41 22.76 15.13 21.61C16.64 20.6 16.64 18.94 15.13 17.94C13.42 16.79 10.6 16.79 8.87005 17.94Z"
                  fill="#767676"
                />
              </svg>

              <p className="">Our Staff</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/rider`}
              className={"nav-link " + (brandName === "Rider" ? "active" : "")}
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M11 13.4752C11.1358 12.6832 14.1687 11.0495 19.9177 11.0495C20.0082 11.0495 20.0988 11.0495 20.1893 11C21.0041 12.8317 21.5926 14.6634 22 16C16.6132 15.802 11.5885 14.4158 11 13.4752Z"
                  fill="#767676"
                />
                <path
                  d="M1.46968 9.06076C2.58949 5.27848 5.7623 3 9.96161 3C11.3614 3 12.7612 3.22785 14.2076 3.72911C16.3072 4.45823 18.1269 6.69114 19.5267 9.1519C14.3942 9.24304 9.16841 10.519 9.16841 13.2076C9.16841 16.2152 18.8268 17.2177 22.8862 17.2633C22.8862 17.3089 22.9328 17.3544 22.9328 17.4C23.1661 18.6304 22.7462 19.4051 22.3729 19.8152C21.7197 20.5899 20.5532 21 19.0135 21C18.7802 21 18.5469 21 18.3602 20.9544L4.22256 19.9063C3.98926 19.9063 3.75597 19.7696 3.56933 19.5873C1.18972 16.8532 0.396521 12.6152 1.46968 9.06076Z"
                  fill="#767676"
                />
              </svg>

              <p className="">Riders</p>
            </Link>
          </li>

          <li>
            <Link
              to={`/admin/collection`}
              className={"nav-link " + (brandName === "Collection" ? "active" : "")}
            >
              <div className="sideborder"></div>
              <svg className="iconns" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21.3 10.8404C21.69 10.8404 22 10.5304 22 10.1404V9.21035C22 5.11035 20.75 3.86035 16.65 3.86035H7.35C3.25 3.86035 2 5.11035 2 9.21035V9.68035C2 10.0704 2.31 10.3804 2.7 10.3804C3.6 10.3804 4.33 11.1104 4.33 12.0104C4.33 12.9104 3.6 13.6304 2.7 13.6304C2.31 13.6304 2 13.9404 2 14.3304V14.8004C2 18.9004 3.25 20.1504 7.35 20.1504H16.65C20.75 20.1504 22 18.9004 22 14.8004C22 14.4104 21.69 14.1004 21.3 14.1004C20.4 14.1004 19.67 13.3704 19.67 12.4704C19.67 11.5704 20.4 10.8404 21.3 10.8404ZM9 8.88035C9.55 8.88035 10 9.33035 10 9.88035C10 10.4304 9.56 10.8804 9 10.8804C8.45 10.8804 8 10.4304 8 9.88035C8 9.33035 8.44 8.88035 9 8.88035ZM15 15.8804C14.44 15.8804 13.99 15.4304 13.99 14.8804C13.99 14.3304 14.44 13.8804 14.99 13.8804C15.54 13.8804 15.99 14.3304 15.99 14.8804C15.99 15.4304 15.56 15.8804 15 15.8804ZM15.9 9.48035L9.17 16.2104C9.02 16.3604 8.83 16.4304 8.64 16.4304C8.45 16.4304 8.26 16.3604 8.11 16.2104C7.82 15.9204 7.82 15.4404 8.11 15.1504L14.84 8.42035C15.13 8.13035 15.61 8.13035 15.9 8.42035C16.19 8.71035 16.19 9.19035 15.9 9.48035Z" fill="#767676" />
              </svg>

              <p className="">Collection</p>
            </Link>
          </li>
          {/* <li>
            <Link
              to={`/admin/promo`}
              className={"nav-link " + (brandName === "Promo" ? "active" : "")}
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M20 12V18C20 20.21 18.21 22 16 22H8C5.79 22 4 20.21 4 18V12C4 11.45 4.45 11 5 11H6.97C7.52 11 7.97 11.45 7.97 12V15.14C7.97 15.88 8.38 16.56 9.03 16.91C9.32 17.07 9.64 17.15 9.97 17.15C10.35 17.15 10.73 17.04 11.06 16.82L12.01 16.2L12.89 16.79C13.5 17.2 14.28 17.25 14.93 16.9C15.59 16.55 16 15.88 16 15.13V12C16 11.45 16.45 11 17 11H19C19.55 11 20 11.45 20 12Z"
                  fill="#767676"
                />
                <path
                  d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z"
                  fill="#767676"
                />
                <path
                  d="M11.64 5H6.12003C5.78003 4.63 5.79003 4.06 6.15003 3.7L7.57003 2.28C7.94003 1.91 8.55003 1.91 8.92003 2.28L11.64 5Z"
                  fill="#767676"
                />
                <path
                  d="M17.8701 5H12.3501L15.0701 2.28C15.4401 1.91 16.0501 1.91 16.4201 2.28L17.8401 3.7C18.2001 4.06 18.2101 4.63 17.8701 5Z"
                  fill="#767676"
                />
                <path
                  d="M13.9699 11C14.5199 11 14.9699 11.45 14.9699 12V15.13C14.9699 15.93 14.0799 16.41 13.4199 15.96L12.5199 15.36C12.1899 15.14 11.7599 15.14 11.4199 15.36L10.4799 15.98C9.81994 16.42 8.93994 15.94 8.93994 15.15V12C8.93994 11.45 9.38994 11 9.93994 11H13.9699Z"
                  fill="#767676"
                />
              </svg>

              <p className="">Promo</p>
            </Link>
          </li> */}
          <li>
            <Link
              to={`/admin/support`}
              className={
                "nav-link " +
                (brandName === "Support"
                  ? "active"
                  : brandName === "SupportDetail"
                    ? "active"
                    : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M2.75006 18.65C2.34006 18.65 2.00006 18.31 2.00006 17.9V12.2C1.95006 9.49 2.96006 6.93 4.84006 5.01C6.72006 3.1 9.24006 2.05 11.9501 2.05C17.4901 2.05 22.0001 6.56 22.0001 12.1V17.8C22.0001 18.21 21.6601 18.55 21.2501 18.55C20.8401 18.55 20.5001 18.21 20.5001 17.8V12.1C20.5001 7.39 16.6701 3.55 11.9501 3.55C9.64006 3.55 7.50006 4.44 5.91006 6.06C4.31006 7.69 3.46006 9.86 3.50006 12.18V17.89C3.50006 18.31 3.17006 18.65 2.75006 18.65Z"
                  fill="#767676"
                />
                <path
                  d="M5.94 12.45H5.81C3.71 12.45 2 14.16 2 16.26V18.14C2 20.24 3.71 21.95 5.81 21.95H5.94C8.04 21.95 9.75 20.24 9.75 18.14V16.26C9.75 14.16 8.04 12.45 5.94 12.45Z"
                  fill="#767676"
                />
                <path
                  d="M18.19 12.45H18.06C15.96 12.45 14.25 14.16 14.25 16.26V18.14C14.25 20.24 15.96 21.95 18.06 21.95H18.19C20.29 21.95 22 20.24 22 18.14V16.26C22 14.16 20.29 12.45 18.19 12.45Z"
                  fill="#767676"
                />
              </svg>

              <p className="">Support</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/role`}
              className={"nav-link " + (brandName === "Role" ? "active" : "")}
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns role-fvrt"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.6298 4.2134C14.6029 4.41631 15.5252 4.80142 16.3523 5.34285L18.8843 3.32827L20.672 5.11614L18.6576 7.64835C19.1989 8.47551 19.583 9.39584 19.7859 10.371L23 10.7365V13.2656L19.7859 13.631C19.583 14.6052 19.1989 15.5266 18.6576 16.3537L20.672 18.8849L18.8843 20.6728L16.3523 18.6582C15.5262 19.1996 14.6039 19.5837 13.6298 19.7866L13.2644 23H10.7356L10.3702 19.7866C9.39712 19.5837 8.4748 19.1986 7.64772 18.6571L5.11575 20.6717L3.32805 18.8839L5.34245 16.3517C4.80106 15.5245 4.41702 14.6042 4.21413 13.629L1 13.2635V10.7344L4.21413 10.369C4.41702 9.3948 4.80106 8.47344 5.34245 7.64628L3.32805 5.1151L5.11575 3.32723L7.64772 5.34182C8.47377 4.80039 9.39608 4.41631 10.3702 4.2134L10.7356 1H13.2644L13.6298 4.2134ZM12.0005 6.76632C14.8896 6.76632 17.2322 9.10908 17.2322 11.9984C17.2322 14.8878 14.8855 17.2306 12.0005 17.2306C9.11452 17.2306 6.76888 14.8868 6.76888 11.9984C6.76888 9.10908 9.11142 6.76632 12.0005 6.76632ZM14.9341 15.4676C14.695 14.5276 14.0035 13.748 13.0998 13.3919C12.4032 13.719 11.5989 13.719 10.9012 13.3919C9.99647 13.747 9.30706 14.5234 9.06691 15.4676C10.7583 16.9003 13.2417 16.9003 14.9341 15.4676ZM12.9114 12.7159C13.5118 12.3856 13.8907 11.7562 13.8907 11.0584C13.8907 10.0139 13.0439 9.16809 12.0005 9.16809C10.9561 9.16809 10.1103 10.0149 10.1103 11.0584C10.1103 11.7562 10.4902 12.3856 11.0896 12.7159C11.6558 13.0275 12.3452 13.0275 12.9114 12.7159Z"
                  fill="#009DE0"
                />
              </svg>

              <p className="">Role Management</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/setting`}
              className={
                "nav-link " + (brandName === "Setting" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M20.1 9.22C18.29 9.22 17.55 7.94 18.45 6.37C18.97 5.46 18.66 4.3 17.75 3.78L16.02 2.79C15.23 2.32 14.21 2.6 13.74 3.39L13.63 3.58C12.73 5.15 11.25 5.15 10.34 3.58L10.23 3.39C9.78 2.6 8.76 2.32 7.97 2.79L6.24 3.78C5.33 4.3 5.02 5.47 5.54 6.38C6.45 7.94 5.71 9.22 3.9 9.22C2.86 9.22 2 10.07 2 11.12V12.88C2 13.92 2.85 14.78 3.9 14.78C5.71 14.78 6.45 16.06 5.54 17.63C5.02 18.54 5.33 19.7 6.24 20.22L7.97 21.21C8.76 21.68 9.78 21.4 10.25 20.61L10.36 20.42C11.26 18.85 12.74 18.85 13.65 20.42L13.76 20.61C14.23 21.4 15.25 21.68 16.04 21.21L17.77 20.22C18.68 19.7 18.99 18.53 18.47 17.63C17.56 16.06 18.3 14.78 20.11 14.78C21.15 14.78 22.01 13.93 22.01 12.88V11.12C22 10.08 21.15 9.22 20.1 9.22ZM12 15.25C10.21 15.25 8.75 13.79 8.75 12C8.75 10.21 10.21 8.75 12 8.75C13.79 8.75 15.25 10.21 15.25 12C15.25 13.79 13.79 15.25 12 15.25Z"
                  fill="#767676"
                />
              </svg>

              <p className="">Settings</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/deliverycharges`}
              className={
                "nav-link " + (brandName === "Delivery Charges" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M11.9646 0.537308V4.2985C11.9646 4.47761 11.7497 4.58507 11.6064 4.47761L10.5318 3.65373C10.4243 3.58208 10.3168 3.58208 10.2452 3.68955L9.5646 4.54925C9.49296 4.65671 9.31385 4.65671 9.24221 4.54925L8.52579 3.68955C8.45415 3.58208 8.31087 3.58208 8.23923 3.65373L7.1646 4.47761C7.02132 4.58507 6.80639 4.47761 6.80639 4.2985V0.537308H1.18251C0.860121 0.537308 0.609375 0.788054 0.609375 1.11044V17.4806C0.609375 17.803 0.860121 18.0537 1.18251 18.0537H10.8542C10.8542 17.9104 10.8183 17.7313 10.8183 17.5881C10.8183 13.9343 13.7915 10.9612 17.4452 10.9612C17.6601 10.9612 17.875 10.9612 18.09 10.997V1.11044C18.09 0.788054 17.8392 0.537308 17.5168 0.537308H11.9646ZM2.75863 6.91343C2.75863 6.6985 2.93773 6.48358 3.18848 6.48358H8.99146C9.20639 6.48358 9.42132 6.66268 9.42132 6.91343V11.5701C9.42132 11.7851 9.24221 12 8.99146 12H3.15266C2.93773 12 2.72281 11.8209 2.72281 11.5701V6.91343H2.75863ZM6.84221 16.3343H2.75863C2.5437 16.3343 2.40042 16.191 2.40042 15.9761C2.40042 15.7612 2.57952 15.6179 2.75863 15.6179H6.84221C7.05714 15.6179 7.20042 15.797 7.20042 15.9761C7.20042 16.191 7.05714 16.3343 6.84221 16.3343ZM10.7467 14.4716H2.75863C2.5437 14.4716 2.40042 14.2925 2.40042 14.1134C2.40042 13.8985 2.57952 13.7552 2.75863 13.7552H10.7467C10.9616 13.7552 11.1049 13.9343 11.1049 14.1134C11.1049 14.3284 10.9258 14.4716 10.7467 14.4716ZM12.8243 9.17014C12.1079 9.17014 12.1079 8.0597 12.8243 8.0597C13.5407 8.09552 13.5407 9.17014 12.8243 9.17014ZM14.9377 10.2089C14.2213 10.2089 14.2213 9.0985 14.9377 9.0985C15.6542 9.0985 15.6542 10.2089 14.9377 10.2089ZM15.3676 7.77313C14.293 7.77313 14.293 6.12537 15.3676 6.12537C16.4422 6.16119 16.4422 7.77313 15.3676 7.77313ZM17.1228 15.0806C16.4422 15.1881 15.9049 15.6179 15.9049 16.1194C15.9049 16.6209 16.4422 17.0149 17.1228 17.1582V15.0806ZM17.8392 19.9881C18.5198 19.8806 19.0571 19.4507 19.0571 18.9492C19.0571 18.4478 18.5198 18.0537 17.8392 17.9104V19.9881Z"
                  fill="#767676"
                />
                <path
                  d="M17.4801 11.6776C14.2204 11.6776 11.6055 14.3284 11.6055 17.5522C11.6055 20.7761 14.2562 23.4269 17.4801 23.4269C20.7398 23.4269 23.3547 20.7761 23.3547 17.5522C23.3547 14.3284 20.7398 11.6776 17.4801 11.6776ZM19.7726 18.9493C19.7726 19.8448 18.9488 20.5612 17.8383 20.7045V20.9194C17.8383 21.1343 17.6592 21.2776 17.4801 21.2776C17.2652 21.2776 17.1219 21.0985 17.1219 20.9194V20.7045C16.0114 20.5612 15.1876 19.8448 15.1876 18.9493C15.1876 18.7343 15.3667 18.591 15.5458 18.591C15.7249 18.591 15.904 18.7702 15.904 18.9493C15.904 19.4507 16.4413 19.8448 17.1219 19.9881V17.8746C16.0114 17.7313 15.1876 17.0149 15.1876 16.1194C15.1876 15.2239 16.0114 14.5075 17.1219 14.3642V14.2209C17.1219 14.006 17.301 13.8627 17.4801 13.8627C17.695 13.8627 17.8383 14.0418 17.8383 14.2209V14.3642C18.9488 14.5075 19.7726 15.2239 19.7726 16.1194C19.7726 16.3343 19.5935 16.4776 19.4144 16.4776C19.2353 16.4776 19.0562 16.2985 19.0562 16.1194C19.0562 15.6179 18.5189 15.2239 17.8383 15.0806V17.194C18.9488 17.3373 19.7726 18.0537 19.7726 18.9493Z"
                  fill="#767676"
                />
              </svg>
              <p className="">Delivery Charges</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/pushnotification`}
              className={
                "nav-link " + (brandName === "Push Notification" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg

                className="iconns"

                xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <g clip-path="url(#clip0_1_3574)">
                  <path d="M9.61173 21C11.1964 21 12.5221 19.8703 12.8265 18.375H6.39697C6.70155 19.8703 8.02718 21 9.61173 21Z" fill="#767676" />
                  <path d="M15.7472 10.4992C15.7437 10.4992 15.7402 10.5 15.7366 10.5C12.3601 10.5 9.6117 7.75244 9.6117 4.37506C9.6117 3.4466 9.82527 2.56893 10.1971 1.7797C10.0046 1.76144 9.80941 1.75006 9.6117 1.75006C6.22903 1.75006 3.48675 4.49218 3.48675 7.87501V10.3145C3.48675 12.0461 2.72812 13.6806 1.3972 14.8058C0.953555 15.1848 0.756648 15.7885 0.915904 16.3774C1.10144 17.0625 1.77867 17.5001 2.48924 17.5001H16.7298C17.4753 17.5001 18.178 17.017 18.3293 16.2864C18.4466 15.7212 18.2453 15.1567 17.807 14.7884C16.5347 13.7218 15.7988 12.1546 15.7472 10.4992Z" fill="#767676" />
                  <path d="M20.1118 4.37505C20.1118 6.79129 18.1531 8.74995 15.7367 8.74995C13.3205 8.74995 11.3618 6.79129 11.3618 4.37505C11.3618 1.95882 13.3205 0 15.7367 0C18.1531 0 20.1118 1.95882 20.1118 4.37505Z" fill="#767676" />
                </g>
                <defs>
                  <clipPath id="clip0_1_3574">
                    <rect width="21" height="21" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p className="">Push Notification</p>
            </Link>
          </li>
          <li className="innnerwraper">
            <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
              <Accordion.Item
                eventKey="0"
                className={activeKey === "0" ? "forborderleft" : ""}
              >
                <Accordion.Header>

                  <div className="innner_drop">

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <g clip-path="url(#clip0_7254_41268)">
                        <path d="M7.47855 8.63184H16.5554H16.7429V8.81932V17.8962V18.0837H16.5554H7.47855H7.29106V17.8962V8.81932V8.63184H7.47855Z" fill="#767676" />
                        <path d="M9.01646 17.709H10.1922H10.3797V17.8965V20.248C10.3797 20.4549 10.2952 20.6429 10.159 20.7791C10.0228 20.9153 9.83479 20.9998 9.62785 20.9998H9.58082C9.37386 20.9998 9.18583 20.9153 9.04966 20.7791C8.9135 20.643 8.82895 20.4549 8.82895 20.248V17.8965V17.709H9.01646Z" fill="#767676" />
                        <path d="M13.8417 17.709H15.0175H15.205V17.8965V20.248C15.205 20.4549 15.1204 20.6429 14.9843 20.7791C14.8481 20.9153 14.6601 20.9998 14.4531 20.9998H14.4061C14.1991 20.9998 14.0111 20.9153 13.8749 20.7791C13.7388 20.643 13.6542 20.4549 13.6542 20.248V17.8965V17.709H13.8417Z" fill="#767676" />
                        <path d="M6.34634 8.69727C6.54037 8.69727 6.71663 8.77652 6.84427 8.90416C6.97192 9.0318 7.05117 9.20807 7.05117 9.40208V14.7052C7.05117 14.8992 6.97192 15.0755 6.84427 15.2031C6.71663 15.3308 6.54037 15.41 6.34634 15.41C6.15232 15.41 5.97605 15.3308 5.84841 15.2031C5.72077 15.0755 5.64151 14.8992 5.64151 14.7052V9.40208C5.64151 9.20807 5.72077 9.0318 5.84841 8.90416C5.97605 8.77652 6.15232 8.69727 6.34634 8.69727Z" fill="#767676" />
                        <path d="M17.7064 8.69727C17.9004 8.69727 18.0767 8.77652 18.2043 8.90416C18.332 9.0318 18.4112 9.20807 18.4112 9.40208V14.7052C18.4112 14.8992 18.332 15.0755 18.2043 15.2031C18.0767 15.3308 17.9004 15.41 17.7064 15.41C17.5124 15.41 17.3361 15.3308 17.2085 15.2031C17.0808 15.0755 17.0016 14.8992 17.0016 14.7052V9.40208C17.0016 9.20807 17.0808 9.0318 17.2085 8.90416C17.3361 8.77652 17.5124 8.69727 17.7064 8.69727Z" fill="#767676" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.06906 4.97854L7.54309 3.45257C7.39671 3.30618 7.39671 3.06867 7.54309 2.92229C7.68948 2.7759 7.92699 2.7759 8.07337 2.92229L9.59934 4.44826C9.74572 4.59465 9.74572 4.83216 9.59934 4.97854C9.45295 5.12493 9.21544 5.12493 9.06906 4.97854Z" fill="#767676" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4001 4.44826L15.926 2.92229C16.0724 2.7759 16.3099 2.7759 16.4563 2.92229C16.6027 3.06867 16.6027 3.30618 16.4563 3.45257L14.9304 4.97854C14.784 5.12493 14.5465 5.12493 14.4001 4.97854C14.2537 4.83216 14.2537 4.59465 14.4001 4.44826Z" fill="#767676" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.57553 5.14971C7.78299 5.94223 7.29106 7.03558 7.29106 8.23841V8.42592H7.47856H16.5554H16.7429V8.2384C16.7429 7.03558 16.251 5.94223 15.4584 5.14971C15.2971 4.98843 15.1234 4.8396 14.9388 4.70485L14.7978 4.84587C14.7246 4.91908 14.6059 4.91908 14.5327 4.84587C14.4595 4.77267 14.4595 4.65394 14.5327 4.58073L14.6205 4.49293C13.962 4.0948 13.1914 3.86523 12.3697 3.86523H11.6642C10.8336 3.86523 10.0552 4.09983 9.39203 4.50598L9.46679 4.58073C9.53999 4.65394 9.53999 4.77267 9.46679 4.84587C9.39358 4.91908 9.27485 4.91908 9.20165 4.84587L9.07522 4.71945C8.89806 4.85034 8.731 4.99425 8.57553 5.14971ZM10.3322 5.5061C10.4469 5.6209 10.518 5.77946 10.518 5.9546C10.518 6.1297 10.4469 6.28829 10.3322 6.40309C10.2174 6.51786 10.0588 6.58888 9.88368 6.58888C9.70855 6.58888 9.54998 6.51786 9.43518 6.40309C9.32041 6.28829 9.2494 6.1297 9.2494 5.9546C9.2494 5.77946 9.32041 5.6209 9.43518 5.5061C9.54998 5.39133 9.70854 5.32031 9.88368 5.32031C10.0588 5.32031 10.2174 5.39133 10.3322 5.5061ZM13.7017 6.40309C13.587 6.28829 13.516 6.1297 13.516 5.9546C13.516 5.77946 13.587 5.6209 13.7017 5.5061C13.8165 5.39133 13.9751 5.32031 14.1502 5.32031C14.3254 5.32031 14.484 5.39133 14.5987 5.5061C14.7135 5.6209 14.7845 5.77946 14.7845 5.9546C14.7845 6.12971 14.7135 6.28829 14.5987 6.40309C14.484 6.51786 14.3254 6.58888 14.1502 6.58888C13.9751 6.58888 13.8165 6.51786 13.7017 6.40309Z" fill="#767676" />
                      </g>
                      <defs>
                        <clipPath id="clip0_7254_41268">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    App Managment

                  </div>
                </Accordion.Header>

                <Accordion.Body>
                  <Link

                    to={`/admin/bannerappmanagment`}
                    className={brandName === "Banner App Managment" ? " nav-link activesss" : "nav-link"}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.5 0.75C3.69891 0.75 3.88968 0.829018 4.03033 0.96967C4.17098 1.11032 4.25 1.30109 4.25 1.5V10C4.25 10.2652 4.35536 10.5196 4.54289 10.7071C4.73043 10.8946 4.98478 11 5.25 11H10.6893L9.21966 9.53034C9.079 9.38969 8.99998 9.19892 8.99998 9C8.99998 8.80108 9.079 8.61031 9.21966 8.46966C9.36031 8.329 9.55108 8.24998 9.75 8.24998C9.94892 8.24998 10.1397 8.329 10.2803 8.46966L13.0303 11.2197C13.1 11.2893 13.1552 11.372 13.1929 11.463C13.2306 11.554 13.25 11.6515 13.25 11.75C13.25 11.8485 13.2306 11.946 13.1929 12.037C13.1552 12.128 13.1 12.2107 13.0303 12.2803L10.2803 15.0303C10.1397 15.171 9.94892 15.25 9.75 15.25C9.55108 15.25 9.36031 15.171 9.21966 15.0303C9.079 14.8897 8.99998 14.6989 8.99998 14.5C8.99998 14.3011 9.079 14.1103 9.21966 13.9697L10.6893 12.5H5.25C4.92169 12.5 4.5966 12.4353 4.29329 12.3097C3.98998 12.1841 3.71438 11.9999 3.48223 11.7678C3.25009 11.5356 3.06594 11.26 2.9403 10.9567C2.81466 10.6534 2.75 10.3283 2.75 10V1.5C2.75 1.30109 2.82902 1.11032 2.96967 0.96967C3.11032 0.829018 3.30109 0.75 3.5 0.75Z" fill="#949494" />
                    </svg>
                    Banners

                  </Link>


                  <Link
                    to={`/admin/mystreybox`}
                    className={brandName === "Banner Mystrey Box" ? " nav-link activesss" : "nav-link"}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.5 0.75C3.69891 0.75 3.88968 0.829018 4.03033 0.96967C4.17098 1.11032 4.25 1.30109 4.25 1.5V10C4.25 10.2652 4.35536 10.5196 4.54289 10.7071C4.73043 10.8946 4.98478 11 5.25 11H10.6893L9.21966 9.53034C9.079 9.38969 8.99998 9.19892 8.99998 9C8.99998 8.80108 9.079 8.61031 9.21966 8.46966C9.36031 8.329 9.55108 8.24998 9.75 8.24998C9.94892 8.24998 10.1397 8.329 10.2803 8.46966L13.0303 11.2197C13.1 11.2893 13.1552 11.372 13.1929 11.463C13.2306 11.554 13.25 11.6515 13.25 11.75C13.25 11.8485 13.2306 11.946 13.1929 12.037C13.1552 12.128 13.1 12.2107 13.0303 12.2803L10.2803 15.0303C10.1397 15.171 9.94892 15.25 9.75 15.25C9.55108 15.25 9.36031 15.171 9.21966 15.0303C9.079 14.8897 8.99998 14.6989 8.99998 14.5C8.99998 14.3011 9.079 14.1103 9.21966 13.9697L10.6893 12.5H5.25C4.92169 12.5 4.5966 12.4353 4.29329 12.3097C3.98998 12.1841 3.71438 11.9999 3.48223 11.7678C3.25009 11.5356 3.06594 11.26 2.9403 10.9567C2.81466 10.6534 2.75 10.3283 2.75 10V1.5C2.75 1.30109 2.82902 1.11032 2.96967 0.96967C3.11032 0.829018 3.30109 0.75 3.5 0.75Z" fill="#949494" />
                    </svg>
                    Mystery Box
                  </Link>




                  <Link
                    to={`/admin/apppushnotification`}
                    className={brandName === "App push notification" ? " nav-link activesss" : "nav-link"}

                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.5 0.75C3.69891 0.75 3.88968 0.829018 4.03033 0.96967C4.17098 1.11032 4.25 1.30109 4.25 1.5V10C4.25 10.2652 4.35536 10.5196 4.54289 10.7071C4.73043 10.8946 4.98478 11 5.25 11H10.6893L9.21966 9.53034C9.079 9.38969 8.99998 9.19892 8.99998 9C8.99998 8.80108 9.079 8.61031 9.21966 8.46966C9.36031 8.329 9.55108 8.24998 9.75 8.24998C9.94892 8.24998 10.1397 8.329 10.2803 8.46966L13.0303 11.2197C13.1 11.2893 13.1552 11.372 13.1929 11.463C13.2306 11.554 13.25 11.6515 13.25 11.75C13.25 11.8485 13.2306 11.946 13.1929 12.037C13.1552 12.128 13.1 12.2107 13.0303 12.2803L10.2803 15.0303C10.1397 15.171 9.94892 15.25 9.75 15.25C9.55108 15.25 9.36031 15.171 9.21966 15.0303C9.079 14.8897 8.99998 14.6989 8.99998 14.5C8.99998 14.3011 9.079 14.1103 9.21966 13.9697L10.6893 12.5H5.25C4.92169 12.5 4.5966 12.4353 4.29329 12.3097C3.98998 12.1841 3.71438 11.9999 3.48223 11.7678C3.25009 11.5356 3.06594 11.26 2.9403 10.9567C2.81466 10.6534 2.75 10.3283 2.75 10V1.5C2.75 1.30109 2.82902 1.11032 2.96967 0.96967C3.11032 0.829018 3.30109 0.75 3.5 0.75Z" fill="#949494" />
                    </svg>
                    Push Notification
                  </Link>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="1"
                className={activeKey === "1" ? "forborderleft" : ""}
                 
              >
                <Accordion.Header>


                  <div className="innner_drop">

                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path d="M14.4553 22.4049C16.3831 22.0414 18.1719 21.1494 19.6224 19.8285C18.7529 19.074 17.7642 18.4693 16.6965 18.0391C16.1671 19.9802 15.3906 21.5085 14.4553 22.4049Z" fill="#767676" />
                      <path d="M12.8529 17.2939V22.5457C14.1588 22.2634 15.3235 20.4281 16.0294 17.8022C15.0041 17.4661 13.932 17.2945 12.8529 17.2939Z" fill="#767676" />
                      <path d="M12.1471 22.5458V17.3223C11.0822 17.3924 10.0351 17.6307 9.0447 18.0281C9.75412 20.5305 10.88 22.2705 12.1471 22.5458Z" fill="#767676" />
                      <path d="M5.73765 20.1386C7.12013 21.2921 8.7751 22.0722 10.5447 22.4044C9.65529 21.5503 8.90706 20.1174 8.38118 18.3174C7.41169 18.7851 6.52006 19.3993 5.73765 20.1386Z" fill="#767676" />
                      <path d="M10.5447 1.5957C8.77454 1.92949 7.11879 2.70938 5.73412 3.86159C6.51841 4.60011 7.41109 5.21428 8.38118 5.68276C8.90706 3.88276 9.65529 2.44982 10.5447 1.5957Z" fill="#767676" />
                      <path d="M9.0447 5.97175C10.0344 6.36746 11.0801 6.60564 12.1435 6.67763V1.4541C10.88 1.7294 9.75412 3.46587 9.0447 5.97175Z" fill="#767676" />
                      <path d="M16.0294 6.20116C15.3235 3.57528 14.1588 1.73645 12.8529 1.4541V6.70587C13.9308 6.71178 15.0028 6.5474 16.0294 6.21881V6.20116Z" fill="#767676" />
                      <path d="M19.6224 4.17217C18.1719 2.85126 16.3831 1.95927 14.4553 1.5957C15.3906 2.49217 16.1671 4.02041 16.6965 5.95806C17.7641 5.52932 18.753 4.92577 19.6224 4.17217Z" fill="#767676" />
                      <path d="M17.4412 11.6472H23.0882C23.0024 9.0352 21.9511 6.5478 20.1376 4.66602C19.1745 5.51037 18.0723 6.18147 16.88 6.64954C17.242 8.2911 17.4301 9.96622 17.4412 11.6472Z" fill="#767676" />
                      <path d="M16.1882 6.88965L15.8918 6.98494C14.9036 7.26771 13.8808 7.41144 12.8529 7.412V11.6473H16.7353C16.7177 10.0468 16.5344 8.45239 16.1882 6.88965Z" fill="#767676" />
                      <path d="M8.86471 6.66016C8.48277 8.29554 8.28157 9.96791 8.26471 11.6472H12.1471V7.38016C11.1121 7.31822 10.0912 7.10905 9.11529 6.75898L8.86471 6.66016Z" fill="#767676" />
                      <path d="M8.19765 6.37398C7.09741 5.86013 6.08782 5.17118 5.20823 4.33398C3.18872 6.24203 2.00404 8.87014 1.91176 11.6469H7.55882C7.57098 9.87073 7.7853 8.10169 8.19765 6.37398Z" fill="#767676" />
                      <path d="M7.55882 12.3525H1.91176C2.00165 15.1295 3.18373 17.7587 5.20118 19.669C6.07784 18.8289 7.08657 18.1385 8.18706 17.6255C7.77828 15.8974 7.56751 14.1283 7.55882 12.3525Z" fill="#767676" />
                      <path d="M8.86471 17.3396C9.91415 16.9273 11.0217 16.682 12.1471 16.6125V12.3525H8.26471C8.28157 14.0318 8.48277 15.7042 8.86471 17.3396Z" fill="#767676" />
                      <path d="M16.7353 12.3525H12.8529V16.5878C13.986 16.5878 15.1122 16.7628 16.1918 17.1067C16.5349 15.5447 16.717 13.9517 16.7353 12.3525Z" fill="#767676" />
                      <path d="M16.8694 17.3502C18.0624 17.8169 19.1648 18.4881 20.1271 19.3337C21.9444 17.4536 22.9996 14.966 23.0882 12.3525H17.4412C17.4267 14.0339 17.235 15.709 16.8694 17.3502Z" fill="#767676" />
                    </svg>
                    Website Management

                  </div>

                </Accordion.Header>

                <Accordion.Body>

                  <Link
                    to={`/admin/bannerwbsitemanagment`}
                    className={brandName === "Banner Website Managment" ? " nav-link activesss" : "nav-link"}
 
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.5 0.75C3.69891 0.75 3.88968 0.829018 4.03033 0.96967C4.17098 1.11032 4.25 1.30109 4.25 1.5V10C4.25 10.2652 4.35536 10.5196 4.54289 10.7071C4.73043 10.8946 4.98478 11 5.25 11H10.6893L9.21966 9.53034C9.079 9.38969 8.99998 9.19892 8.99998 9C8.99998 8.80108 9.079 8.61031 9.21966 8.46966C9.36031 8.329 9.55108 8.24998 9.75 8.24998C9.94892 8.24998 10.1397 8.329 10.2803 8.46966L13.0303 11.2197C13.1 11.2893 13.1552 11.372 13.1929 11.463C13.2306 11.554 13.25 11.6515 13.25 11.75C13.25 11.8485 13.2306 11.946 13.1929 12.037C13.1552 12.128 13.1 12.2107 13.0303 12.2803L10.2803 15.0303C10.1397 15.171 9.94892 15.25 9.75 15.25C9.55108 15.25 9.36031 15.171 9.21966 15.0303C9.079 14.8897 8.99998 14.6989 8.99998 14.5C8.99998 14.3011 9.079 14.1103 9.21966 13.9697L10.6893 12.5H5.25C4.92169 12.5 4.5966 12.4353 4.29329 12.3097C3.98998 12.1841 3.71438 11.9999 3.48223 11.7678C3.25009 11.5356 3.06594 11.26 2.9403 10.9567C2.81466 10.6534 2.75 10.3283 2.75 10V1.5C2.75 1.30109 2.82902 1.11032 2.96967 0.96967C3.11032 0.829018 3.30109 0.75 3.5 0.75Z" fill="#949494" />
                    </svg>
                    Banner
                  </Link>




                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="2"
                className={activeKey === "2" ? "forborderleft" : ""}
              >
                <Accordion.Header>

                  <div className="innner_drop">

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M21.3 10.8404C21.69 10.8404 22 10.5304 22 10.1404V9.21035C22 5.11035 20.75 3.86035 16.65 3.86035H7.35C3.25 3.86035 2 5.11035 2 9.21035V9.68035C2 10.0704 2.31 10.3804 2.7 10.3804C3.6 10.3804 4.33 11.1104 4.33 12.0104C4.33 12.9104 3.6 13.6304 2.7 13.6304C2.31 13.6304 2 13.9404 2 14.3304V14.8004C2 18.9004 3.25 20.1504 7.35 20.1504H16.65C20.75 20.1504 22 18.9004 22 14.8004C22 14.4104 21.69 14.1004 21.3 14.1004C20.4 14.1004 19.67 13.3704 19.67 12.4704C19.67 11.5704 20.4 10.8404 21.3 10.8404ZM9 8.88035C9.55 8.88035 10 9.33035 10 9.88035C10 10.4304 9.56 10.8804 9 10.8804C8.45 10.8804 8 10.4304 8 9.88035C8 9.33035 8.44 8.88035 9 8.88035ZM15 15.8804C14.44 15.8804 13.99 15.4304 13.99 14.8804C13.99 14.3304 14.44 13.8804 14.99 13.8804C15.54 13.8804 15.99 14.3304 15.99 14.8804C15.99 15.4304 15.56 15.8804 15 15.8804ZM15.9 9.48035L9.17 16.2104C9.02 16.3604 8.83 16.4304 8.64 16.4304C8.45 16.4304 8.26 16.3604 8.11 16.2104C7.82 15.9204 7.82 15.4404 8.11 15.1504L14.84 8.42035C15.13 8.13035 15.61 8.13035 15.9 8.42035C16.19 8.71035 16.19 9.19035 15.9 9.48035Z" fill="#767676" />
                    </svg>
                    Discount

                  </div>

                </Accordion.Header>

                <Accordion.Body>


                  <Link
                    to={`/admin/coupandiscount`}
                    className={brandName === "Coupan" ? " nav-link activesss" : "nav-link"}

                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.5 0.75C3.69891 0.75 3.88968 0.829018 4.03033 0.96967C4.17098 1.11032 4.25 1.30109 4.25 1.5V10C4.25 10.2652 4.35536 10.5196 4.54289 10.7071C4.73043 10.8946 4.98478 11 5.25 11H10.6893L9.21966 9.53034C9.079 9.38969 8.99998 9.19892 8.99998 9C8.99998 8.80108 9.079 8.61031 9.21966 8.46966C9.36031 8.329 9.55108 8.24998 9.75 8.24998C9.94892 8.24998 10.1397 8.329 10.2803 8.46966L13.0303 11.2197C13.1 11.2893 13.1552 11.372 13.1929 11.463C13.2306 11.554 13.25 11.6515 13.25 11.75C13.25 11.8485 13.2306 11.946 13.1929 12.037C13.1552 12.128 13.1 12.2107 13.0303 12.2803L10.2803 15.0303C10.1397 15.171 9.94892 15.25 9.75 15.25C9.55108 15.25 9.36031 15.171 9.21966 15.0303C9.079 14.8897 8.99998 14.6989 8.99998 14.5C8.99998 14.3011 9.079 14.1103 9.21966 13.9697L10.6893 12.5H5.25C4.92169 12.5 4.5966 12.4353 4.29329 12.3097C3.98998 12.1841 3.71438 11.9999 3.48223 11.7678C3.25009 11.5356 3.06594 11.26 2.9403 10.9567C2.81466 10.6534 2.75 10.3283 2.75 10V1.5C2.75 1.30109 2.82902 1.11032 2.96967 0.96967C3.11032 0.829018 3.30109 0.75 3.5 0.75Z" fill="#949494" />
                    </svg>

                    Coupan
                  </Link>


                  <Link
                    to={`/admin/bulkdiscount`}
                    className={brandName === "Bulk Discount" ? " nav-link activesss" : "nav-link"}

                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.5 0.75C3.69891 0.75 3.88968 0.829018 4.03033 0.96967C4.17098 1.11032 4.25 1.30109 4.25 1.5V10C4.25 10.2652 4.35536 10.5196 4.54289 10.7071C4.73043 10.8946 4.98478 11 5.25 11H10.6893L9.21966 9.53034C9.079 9.38969 8.99998 9.19892 8.99998 9C8.99998 8.80108 9.079 8.61031 9.21966 8.46966C9.36031 8.329 9.55108 8.24998 9.75 8.24998C9.94892 8.24998 10.1397 8.329 10.2803 8.46966L13.0303 11.2197C13.1 11.2893 13.1552 11.372 13.1929 11.463C13.2306 11.554 13.25 11.6515 13.25 11.75C13.25 11.8485 13.2306 11.946 13.1929 12.037C13.1552 12.128 13.1 12.2107 13.0303 12.2803L10.2803 15.0303C10.1397 15.171 9.94892 15.25 9.75 15.25C9.55108 15.25 9.36031 15.171 9.21966 15.0303C9.079 14.8897 8.99998 14.6989 8.99998 14.5C8.99998 14.3011 9.079 14.1103 9.21966 13.9697L10.6893 12.5H5.25C4.92169 12.5 4.5966 12.4353 4.29329 12.3097C3.98998 12.1841 3.71438 11.9999 3.48223 11.7678C3.25009 11.5356 3.06594 11.26 2.9403 10.9567C2.81466 10.6534 2.75 10.3283 2.75 10V1.5C2.75 1.30109 2.82902 1.11032 2.96967 0.96967C3.11032 0.829018 3.30109 0.75 3.5 0.75Z" fill="#949494" />
                    </svg>
                    Bulk CSV Discount
                  </Link>



                  <Link
                    to={`/admin/categorydiscount`}
                    className={brandName === "Category Discount" ? " nav-link activesss" : "nav-link"}

                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3.5 0.75C3.69891 0.75 3.88968 0.829018 4.03033 0.96967C4.17098 1.11032 4.25 1.30109 4.25 1.5V10C4.25 10.2652 4.35536 10.5196 4.54289 10.7071C4.73043 10.8946 4.98478 11 5.25 11H10.6893L9.21966 9.53034C9.079 9.38969 8.99998 9.19892 8.99998 9C8.99998 8.80108 9.079 8.61031 9.21966 8.46966C9.36031 8.329 9.55108 8.24998 9.75 8.24998C9.94892 8.24998 10.1397 8.329 10.2803 8.46966L13.0303 11.2197C13.1 11.2893 13.1552 11.372 13.1929 11.463C13.2306 11.554 13.25 11.6515 13.25 11.75C13.25 11.8485 13.2306 11.946 13.1929 12.037C13.1552 12.128 13.1 12.2107 13.0303 12.2803L10.2803 15.0303C10.1397 15.171 9.94892 15.25 9.75 15.25C9.55108 15.25 9.36031 15.171 9.21966 15.0303C9.079 14.8897 8.99998 14.6989 8.99998 14.5C8.99998 14.3011 9.079 14.1103 9.21966 13.9697L10.6893 12.5H5.25C4.92169 12.5 4.5966 12.4353 4.29329 12.3097C3.98998 12.1841 3.71438 11.9999 3.48223 11.7678C3.25009 11.5356 3.06594 11.26 2.9403 10.9567C2.81466 10.6534 2.75 10.3283 2.75 10V1.5C2.75 1.30109 2.82902 1.11032 2.96967 0.96967C3.11032 0.829018 3.30109 0.75 3.5 0.75Z" fill="#949494" />
                    </svg>
                    Category Discount
                  </Link>

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>


          <li>
            <Link
              to={`/admin/unit`}
              className={"nav-link " + (brandName === "Unit" ? "active" : "")}
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns force__change__color"
              >
                <path
                  d="M23.7735 10.7145L20.157 4.137C20.148 4.1205 20.1285 4.1145 20.118 4.0995C20.0307 3.95919 19.8989 3.85221 19.7436 3.79565C19.5883 3.73909 19.4186 3.73622 19.2615 3.7875L13.5 5.706V3.75C13.5 3.55109 13.421 3.36032 13.2803 3.21967C13.1397 3.07902 12.9489 3 12.75 3C12.5511 3 12.3603 3.07902 12.2197 3.21967C12.079 3.36032 12 3.55109 12 3.75V6.204L5.7375 8.2875C5.6865 8.304 5.6475 8.3385 5.6025 8.3655H5.601C5.50054 8.42384 5.41523 8.50504 5.352 8.6025C5.3445 8.613 5.331 8.6175 5.3235 8.6295L1.599 15.192C1.52218 15.3341 1.49424 15.4975 1.5195 15.657C1.515 15.6885 1.5 15.717 1.5 15.75C1.5 17.295 3.8325 19.5 6 19.5C8.1675 19.5 10.5 17.295 10.5 15.75C10.4994 15.6567 10.4806 15.5645 10.4445 15.4785L10.443 15.4695L10.4385 15.4545C10.426 15.3626 10.3971 15.2736 10.353 15.192L7.0785 9.4245L12 7.7865V20.25C12 20.4489 12.079 20.6397 12.2197 20.7803C12.3603 20.921 12.5511 21 12.75 21C12.9489 21 13.1397 20.921 13.2803 20.7803C13.421 20.6397 13.5 20.4489 13.5 20.25V7.287L17.919 5.817L15.2265 10.716C15.1547 10.7852 15.0977 10.8681 15.0588 10.9599C15.0198 11.0517 14.9999 11.1503 15 11.25C15 12.795 17.3325 15 19.5 15C21.6675 15 24 12.795 24 11.25C24 11.1501 23.98 11.0513 23.941 10.9593C23.9021 10.8673 23.8452 10.7841 23.7735 10.7145ZM3.432 15L5.976 10.5195L8.5185 15H3.432ZM17.058 10.5L19.5 6.057L21.942 10.5H17.058Z"
                  fill="#009DE0"
                />
              </svg>

              <p className="">Unit</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/bannermanagement`}
              className={
                "nav-link " +
                (brandName === "Banner Management" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns force__change__color"
              >
                <path
                  d="M0.357422 5.74146L1.98966 15.0732C8.4765 13.0508 14.487 12.7281 22.0089 15.0732L23.6391 5.75383C15.8495 2.78215 8.08566 2.98484 0.357422 5.74146Z"
                  fill="#009DE0"
                />
                <path
                  d="M2.79027 3.33539C2.65827 2.57845 1.94319 2.06189 1.16286 2.19417C0.400302 2.32978 -0.11387 3.05452 0.0216923 3.8236L0.112067 4.33608C0.956942 4.03481 1.46849 3.85763 2.8161 3.48183L2.79027 3.33539Z"
                  fill="#009DE0"
                />
                <path
                  d="M4.96983 15.6979C3.73097 15.9915 3.40514 16.1051 2.25 16.4652L3.19547 21.8279L5.96475 21.3397L4.96983 15.6979Z"
                  fill="#009DE0"
                />
                <path
                  d="M22.8377 2.19489C22.1004 2.06692 21.3594 2.47844 21.1855 3.46384C22.4629 3.81606 23.075 4.03361 23.8858 4.34308L23.9775 3.82295C24.1131 3.05533 23.5991 2.32933 22.8377 2.19489Z"
                  fill="#009DE0"
                />
                <path
                  d="M19.0298 15.6978L18.0352 21.3397L20.8044 21.8279L21.75 16.465C20.5876 16.1026 20.2664 15.9906 19.0298 15.6978Z"
                  fill="#009DE0"
                />
              </svg>
              <p className="">Banner</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/discount`}
              className={
                "nav-link " + (brandName === "Discount" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                className="iconns force__change__color"
              >
                <path
                  d="M19.3 7.83999C19.69 7.83999 20 7.52999 20 7.13999V6.20999C20 2.10999 18.75 0.859985 14.65 0.859985H5.35C1.25 0.859985 0 2.10999 0 6.20999V6.67999C0 7.06999 0.31 7.37999 0.7 7.37999C1.6 7.37999 2.33 8.10999 2.33 9.00999C2.33 9.90999 1.6 10.63 0.7 10.63C0.31 10.63 0 10.94 0 11.33V11.8C0 15.9 1.25 17.15 5.35 17.15H14.65C18.75 17.15 20 15.9 20 11.8C20 11.41 19.69 11.1 19.3 11.1C18.4 11.1 17.67 10.37 17.67 9.46999C17.67 8.56999 18.4 7.83999 19.3 7.83999ZM7 5.87999C7.55 5.87999 8 6.32999 8 6.87999C8 7.42999 7.56 7.87999 7 7.87999C6.45 7.87999 6 7.42999 6 6.87999C6 6.32999 6.44 5.87999 7 5.87999ZM13 12.88C12.44 12.88 11.99 12.43 11.99 11.88C11.99 11.33 12.44 10.88 12.99 10.88C13.54 10.88 13.99 11.33 13.99 11.88C13.99 12.43 13.56 12.88 13 12.88ZM13.9 6.47999L7.17 13.21C7.02 13.36 6.83 13.43 6.64 13.43C6.45 13.43 6.26 13.36 6.11 13.21C5.82 12.92 5.82 12.44 6.11 12.15L12.84 5.41999C13.13 5.12999 13.61 5.12999 13.9 5.41999C14.19 5.70999 14.19 6.18999 13.9 6.47999Z"
                  fill="#009DE0"
                />
              </svg>
              <p className="">Discount</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/discountCSV`}
              className={
                "nav-link " + (brandName === "DiscountCSV" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                className="iconns force__change__color"
              >
                <path
                  d="M19.3 7.83999C19.69 7.83999 20 7.52999 20 7.13999V6.20999C20 2.10999 18.75 0.859985 14.65 0.859985H5.35C1.25 0.859985 0 2.10999 0 6.20999V6.67999C0 7.06999 0.31 7.37999 0.7 7.37999C1.6 7.37999 2.33 8.10999 2.33 9.00999C2.33 9.90999 1.6 10.63 0.7 10.63C0.31 10.63 0 10.94 0 11.33V11.8C0 15.9 1.25 17.15 5.35 17.15H14.65C18.75 17.15 20 15.9 20 11.8C20 11.41 19.69 11.1 19.3 11.1C18.4 11.1 17.67 10.37 17.67 9.46999C17.67 8.56999 18.4 7.83999 19.3 7.83999ZM7 5.87999C7.55 5.87999 8 6.32999 8 6.87999C8 7.42999 7.56 7.87999 7 7.87999C6.45 7.87999 6 7.42999 6 6.87999C6 6.32999 6.44 5.87999 7 5.87999ZM13 12.88C12.44 12.88 11.99 12.43 11.99 11.88C11.99 11.33 12.44 10.88 12.99 10.88C13.54 10.88 13.99 11.33 13.99 11.88C13.99 12.43 13.56 12.88 13 12.88ZM13.9 6.47999L7.17 13.21C7.02 13.36 6.83 13.43 6.64 13.43C6.45 13.43 6.26 13.36 6.11 13.21C5.82 12.92 5.82 12.44 6.11 12.15L12.84 5.41999C13.13 5.12999 13.61 5.12999 13.9 5.41999C14.19 5.70999 14.19 6.18999 13.9 6.47999Z"
                  fill="#009DE0"
                />
              </svg>
              <p className="">Discount CSV</p>
            </Link>
          </li>
          <li>
            <Link
              to={`/admin/banktransfer`}
              className={
                "nav-link " + (brandName === "Bank Information" ? "active" : "")
              }
            >
              <div className="sideborder"></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="iconns"
              >
                <path
                  d="M22 19V22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19Z"
                  fill="#009DE0"
                  stroke="#009DE0"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M7 11H5V18H7V11Z" fill="#009DE0" />
                <path d="M11 11H9V18H11V11Z" fill="#009DE0" />
                <path d="M15 11H13V18H15V11Z" fill="#009DE0" />
                <path d="M19 11H17V18H19V11Z" fill="#009DE0" />
                <path
                  d="M23 22.75H1C0.59 22.75 0.25 22.41 0.25 22C0.25 21.59 0.59 21.25 1 21.25H23C23.41 21.25 23.75 21.59 23.75 22C23.75 22.41 23.41 22.75 23 22.75Z"
                  fill="#009DE0"
                />
                <path
                  d="M21.37 5.75L12.37 2.15C12.17 2.07 11.83 2.07 11.63 2.15L2.63 5.75C2.28 5.89 2 6.3 2 6.68V10C2 10.55 2.45 11 3 11H21C21.55 11 22 10.55 22 10V6.68C22 6.3 21.72 5.89 21.37 5.75ZM12 8.5C11.17 8.5 10.5 7.83 10.5 7C10.5 6.17 11.17 5.5 12 5.5C12.83 5.5 13.5 6.17 13.5 7C13.5 7.83 12.83 8.5 12 8.5Z"
                  fill="#009DE0"
                />
              </svg>
              <p className="">Bank Information</p>
            </Link>
          </li>
        </Nav>
      </div>
    </div >
  );
}

export default Sidebar;
